/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */

import { Component, Input } from '@angular/core';
import { VariantProps, cva } from 'class-variance-authority';

export const formRowVariants = cva('flex flex-col gap-4', {
  variants: {
    variant: {
      default: 'md:flex-row',
      highlighted: 'bg-background-150 border-grayborder rounded-md border p-4',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
export type FormRowVariants = VariantProps<typeof formRowVariants>;

@Component({
  selector: 'ods-form-row',
  imports: [],
  host: { '[class]': 'formRowVariants({ variant })' },
  template: `<ng-content />`,
})
export class FormRowComponent {
  @Input() variant: FormRowVariants['variant'] = 'default';

  public readonly formRowVariants = formRowVariants;
}
